/**
 * Calendar event filtering, shared by the week grid and the day grid so the two can never
 * drift apart.
 */
import { FILTER_NONE } from '../calendarConstants';

/**
 * Apply the filter panel's selections to the calendar events.
 * Cancelled work orders are always dropped: they are not part of the calendar at all.
 */
export function applyEventFilters(events, filters) {
  let result = events.filter((event) => event.state !== 'cancelled');

  if (filters.states.length > 0) {
    result = result.filter((event) => filters.states.includes(event.state));
  }

  if (filters.employees.length > 0) {
    const includeNoEmployee = filters.employees.includes(FILTER_NONE);
    const employeeIds = filters.employees.filter((id) => id !== FILTER_NONE);
    result = result.filter((event) => {
      const hasEmployee = event.employee_ids?.length > 0;
      if (!hasEmployee) return includeNoEmployee;
      return employeeIds.length > 0 && event.employee_ids.some((id) => employeeIds.includes(id));
    });
  }

  if (filters.serviceBays.length > 0) {
    const includeNoBay = filters.serviceBays.includes(FILTER_NONE);
    const bayIds = filters.serviceBays.filter((id) => id !== FILTER_NONE);
    result = result.filter((event) => {
      if (!event.service_bay_id) return includeNoBay;
      return bayIds.length > 0 && bayIds.includes(event.service_bay_id);
    });
  }

  const colorTagFilter = filters.colorTags || [];
  if (colorTagFilter.length > 0) {
    const includeNoTag = colorTagFilter.includes(FILTER_NONE);
    const tagIds = colorTagFilter.filter((id) => id !== FILTER_NONE);
    result = result.filter((event) => {
      if (!event.color_tag_id) return includeNoTag;
      return tagIds.length > 0 && tagIds.includes(event.color_tag_id);
    });
  }

  return result;
}

export default applyEventFilters;
